import { defineStore } from 'pinia'


export const useUserStore = defineStore('user', {
  state: () => ({
    nome: '',
    autenticado: false,
    grupos: [], 
    permissions: [],
    notifications: false, // 🔥 Adicionado controle de notificações
  }),

  actions: {
    login(nome, grupos = [], permissions = [], notifications = false) {
      this.nome = nome
      this.autenticado = true
      this.grupos = grupos
      this.permissions = permissions
      this.notifications = notifications
    },

    logout() {
      this.nome = ''
      this.autenticado = false
      this.grupos = []
      this.permissions = []
      this.notifications = false
    },

    setNotificationsStatus(status) {
      this.notifications = status
    }
  },
})
